import { AccordionMinus2, AccordionPlus2 } from "../../../images";
import AccordionList from "../../courseDetails/accordion";
import AccordianCard from "../../courseDetails/resource-cards";

const ProjectDeliverables = ({ course }) => {
  const SECTIONS = course?.deliverables || [];
  if (SECTIONS.length === 0) {
    return (
      <div className="mt-[40px] p-8 bg-white rounded-[4px] text-center text-[#828282] border border-gray-100">
        No Deliverables available for this course yet.
      </div>
    );
  }

  return (
    <AccordionList
      sections={SECTIONS}
      type="deliverables"
      icons={{ plus: AccordionPlus2, minus: AccordionMinus2 }}
      renderItem={(item, index) => (
        <AccordianCard key={index} item={item} tab="deliverables" />
      )}
      emptyMessage="No resources available"
    />
  );
};

export default ProjectDeliverables;
